$(function () {
  // initialeze
  sortable()
  let tableElementField = ".formExplanationTableElementField"
  let tableLastElement = ".formExplanationTableElementField:last";
  let tableElementHtml = $(tableLastElement).prop("outerHTML");
  if (/common_forms\/\d+\/edit/.test(location.pathname)) {
    $(tableLastElement).remove();
    tableElementHtml = tableElementHtml.replace(/\[form_explanation_table_elements_attributes\]\[\d+\]/g, "[form_explanation_table_elements_attributes][0]")
                         .replace(/form_explanation_table_elements_attributes_\d+/g, "form_explanation_table_elements_attributes_0");
  }
  let addTableElementBtn = ".addFormExplanationTableElement";
  let tableElementCnt = $(tableElementField).length;
  let lastTableElementNo = tableElementCnt - 1;
  let tableElementOrder = ".formExplanationTableElementOrder"
  $(tableElementField).each(function(i, elem){
    $(elem).attr("id", `formExplanationTableElementFieldNo${i}`);
  });
  sortFormExplanationTableElements();

  // add
  $(addTableElementBtn).click(function () {
    tableElementCnt = $(tableElementField).length;
    lastTableElementNo++;
    let addTableElementHtml = tableElementHtml.replace(/\[form_explanation_table_elements_attributes\]\[0\]/g, "[form_explanation_table_elements_attributes][" + lastTableElementNo + "]")
                                .replace(/form_explanation_table_elements_attributes_0/g, "form_explanation_table_elements_attributes_" + lastTableElementNo);
    if (tableElementCnt > 0) {
      let nextOrderVal = Number($(tableLastElement).find(tableElementOrder).val()) + 1
      $(tableLastElement).after(addTableElementHtml);
      $(tableLastElement).find(tableElementOrder).val(nextOrderVal)
    } else {
      $(".formExplanationTableElementsWrapper").append(addTableElementHtml);
    }
    $(tableLastElement).attr("id", `formExplanationTableElementFieldNo${lastTableElementNo}`);
    sortable();
  });

  // remove
  let removeTableElemBtn = ".removeFormExplanationTableElement"
  $(document).on('click', removeTableElemBtn, function() {
    $(this).parent().remove();
  });

  // sort
  function sortable() {
    $(".sortableFormExplanationTableElements").sortable({
      "cancel":".unsoartable",
      "handle":".sortHandle",
      update: function(event, ui) {
        // orderの値を反映
        $(event.target).find(tableElementField).each(function(index, field){
          $(field).find(tableElementOrder).val(index);
        });
      }
    });
  };
  function sortFormExplanationTableElements() {
    $(tableElementField).sort((a,b) => {
      if (Number($(a).find(tableElementOrder).val()) >= Number($(b).find(tableElementOrder).val())) {
        return 1;
      } else {
        return -1;
      }
    }).appendTo($(".formExplanationTableElementsWrapper"));
  };
});
